import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68924432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "card card-custom gutter-b" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "Geo Whitelist")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
], -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "clearfix" }, " ", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "card card-custom gutter-b col-md-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "Timeframe Restrictions")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
], -1))
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "timeframe-restrictions" }
const _hoisted_13 = { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "limit-inputs"
}
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = {
  key: 1,
  class: "form-check form-check-sm form-check-custom form-check-solid"
}
const _hoisted_21 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_geo_selector = _resolveComponent("geo-selector")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_geo_selector, {
              modelValue: _ctx.offer.geo_targeting.whitelist,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.offer.geo_targeting.whitelist) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_13, [
                  _hoisted_14,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (item, index) => {
                    return _createElementVNode("th", {
                      class: "text-center clickable-table-header",
                      onClick: ($event: any) => (_ctx.toggleColumn(index))
                    }, _toDisplayString(('0' + index.toString()).slice(-2)), 9, _hoisted_15)
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer_ref.restrict_timeframe_schedule, (entity, entityIndex) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: entity.day+entityIndex
                  }, [
                    _createElementVNode("td", {
                      class: "clickable-table-header text-center",
                      onClick: ($event: any) => (_ctx.toggleRow(entityIndex))
                    }, _toDisplayString(entity.day), 9, _hoisted_16),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entity.hours, (hour, hourIndex) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: "position-relative timeframe-entity-checkbox",
                        key: entity.day+entityIndex+hourIndex
                      }, [
                        (_ctx.offer_ref.restrict_timeframe_mode === 'limit')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((hour.impressions) = $event),
                                type: "text"
                              }, null, 8, _hoisted_18), [
                                [_vModelText, hour.impressions]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((hour.clicks) = $event),
                                type: "text"
                              }, null, 8, _hoisted_19), [
                                [_vModelText, hour.clicks]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((hour.enabled) = $event)
                              }, null, 8, _hoisted_21), [
                                [_vModelCheckbox, hour.enabled]
                              ])
                            ]))
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}